import { createFileRoute } from '@tanstack/react-router'
import { TutorListPage } from '_/features/pets/ui/pages/tutor-list-page'

const TutorListRoute = () => {
	const { petId } = Route.useParams()
	return <TutorListPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/tutors')({
	staticData: { title: 'tutors_title' },
	component: TutorListRoute,
})
